import { useContext } from "react";

import { VenueContext } from "../VenueContext";

const useVenue = () => {
  const venue = useContext(VenueContext);

  return {
    isBexley: venue === "Bexley",
    isEltham: venue === "Eltham",
    venue,
  };
};

export default useVenue;
